import { Grid, TextField } from '@material-ui/core'
import { IOProps } from 'react-compose-io'
import { Controller } from 'react-hook-form'
import { CustomDialog } from '../../../../components/CustomDialog/CustomDialog'
import { Botao } from '../../../../components/Botao'
import { ModalApiGenerationIO } from './ApiGenerationModal.IO'
import { ManualApiPayload } from '../../../../types/ciclosApiType'
import { DateTimeInput } from '../../../../components/DateTimeInput'

// Props que o componente recebe do pai (CardExpansivel)
export type ModalApiGenerationProps = {
  isShow: boolean
  isClosed: () => void
  handleConfirmar: (data: ManualApiPayload) => Promise<void>
  isLoading: boolean
}

export default function ModalApiGenerationView({ _io, isShow, isLoading }: IOProps<ModalApiGenerationIO, ModalApiGenerationProps>) {
  return (
    <CustomDialog
      open={isShow}
      onClose={_io.fecharModal}
      id="modal-gerar-api-manual"
      titulo="Gerar Arquivo API Manualmente"
      habilitarAcoes
      fecharHabilitado={!isLoading}
      fecharModal={_io.fecharModal}
      actions={
        <Grid container spacing={2} alignContent="center" justifyContent="center">
          <Grid item>
            <Botao textoBotao="Cancelar" onClick={_io.fecharModal} estilo="text" cor="primaria" width="156px" disabled={isLoading} />
          </Grid>
          <Grid item>
            <Botao textoBotao="Gerar Arquivo" onClick={_io.handleSubmit(_io.submit)} estilo="rounded" cor="primaria" width="156px" disabled={isLoading} />
          </Grid>
        </Grid>
      }
    >
      <form>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Controller<ManualApiPayload, 'startDate'>
              name="startDate"
              control={_io.control}
              render={({ field: { value, onChange }, fieldState: { error } }) => (
                <DateTimeInput
                  value={value}
                  onChange={onChange}
                  label="Data inicial do ciclo"
                  required
                  inputVariant="outlined"
                  fullWidth
                  error={!!error}
                  helperText={error?.message}
                  disabled={isLoading}
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Controller<ManualApiPayload, 'endDate'>
              name="endDate"
              control={_io.control}
              render={({ field: { value, onChange }, fieldState: { error } }) => (
                <DateTimeInput
                  value={value}
                  onChange={onChange}
                  label="Data final do ciclo"
                  required
                  inputVariant="outlined"
                  fullWidth
                  error={!!error}
                  helperText={error?.message}
                  disabled={isLoading}
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Controller<ManualApiPayload, 'comment'>
              name="comment"
              control={_io.control}
              render={({ field }) => (
                <TextField
                  {...field}
                  required
                  label="Comentário"
                  variant="outlined"
                  size="small"
                  fullWidth
                  error={!!_io.errors.comment}
                  helperText={_io.errors.comment?.message}
                  disabled={isLoading}
                />
              )}
            />
          </Grid>
        </Grid>
      </form>
    </CustomDialog>
  )
}
